import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface VideoCardProps {
  id: string;
  title: string;
  image: string;
  rating: number;
  year: string;
  region: string;
  category: string;
  tags: string[];
  updateEpisode: string;
  isHot: boolean;
}

export default function VideoCard({
  id,
  title,
  image,
  rating,
  year,
  region,
  category,
  tags,
  updateEpisode,
  isHot,
}: VideoCardProps) {
  const { t } = useTranslation();

  return (
    <Link
      to={`/article/${id}`}
      className="group block no-underline"
      title={`${title} - ${t('site.name')}`}
    >
      <div className="relative aspect-[3/4] rounded-lg overflow-hidden bg-background-200">
        <img
          src={image}
          alt={`${title} 海报`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>

        {isHot && (
          <span className="absolute top-2 left-2 bg-primary-500 text-background-50 text-xs font-semibold px-2 py-0.5 rounded-full">
            HOT
          </span>
        )}

        <span className="absolute top-2 right-2 bg-background-50/90 text-primary-600 text-xs font-bold px-1.5 py-0.5 rounded">
          {rating}
        </span>

        <div className="absolute bottom-0 left-0 right-0 p-3">
          <p className="text-background-50 text-xs mb-1 opacity-80">
            {year} · {region} · {category}
          </p>
        </div>

        <span className="absolute bottom-10 right-2 bg-accent-500 text-background-50 text-[10px] font-medium px-1.5 py-0.5 rounded">
          {updateEpisode}
        </span>
      </div>

      <div className="mt-2.5 px-0.5">
        <h3 className="text-sm font-semibold text-foreground-900 truncate group-hover:text-primary-500 transition-colors">
          {title}
        </h3>
        <div className="flex items-center gap-1.5 mt-1 flex-wrap">
          {tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="text-[10px] text-secondary-600 bg-secondary-100 px-1.5 py-0.5 rounded"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}